'use client';

import { SectionHeading } from "@/components/taller/section-heading";
import { useTranslations } from "@/i18n/client";
import { faqSchema } from "@/lib/structured-data";

/** Modern FAQ section with clean accordion styles. */
export function Faq() {
  const { t, isLoading } = useTranslations();
  const faq = t('faq');

  if (isLoading) return null;

  const items = faq.items ?? [];

  return (
    <section className="py-24 md:py-32">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema(items)) }}
      />
      <div className="max-w-[var(--container-max)] mx-auto px-6 md:px-14">
        <SectionHeading
          overline={faq.overline || 'Preguntas frecuentes'}
          heading={
            <>
              {faq.heading || 'Lo que suelen '}
              <em>{faq.headingAccent || 'preguntarnos.'}</em>
            </>
          }
          className="mb-16"
        />

        <div className="border-t border-[var(--color-border)]">
          {items.map((f, i) => (
            <details
              key={f.q}
              className="border-b border-[var(--color-border)] py-8 group"
              open={i === 0}
            >
              <summary className="flex justify-between items-center gap-6 font-sans font-medium text-[18px] md:text-[20px] tracking-tight text-[var(--color-ink)] list-none cursor-pointer">
                <span className="flex items-start gap-4">

                  {f.q}
                </span>
                <span
                  aria-hidden
                  className="font-mono text-[24px] text-[var(--color-mute)] transition-transform duration-300 group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <div className="font-sans text-[15px] leading-[1.7] text-[var(--color-mute)] mt-6 max-w-[720px] pl-10 md:pl-12">
                {f.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
